import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, Thumbs } from 'swiper/modules';
// Swiper.use([Pagination, Navigation, Autoplay, EffectFade]);

import { lazyLoadImages } from './functions.js';

const swiperSliderSeasons = (selector) => {

	const swiperSliders = document.querySelectorAll(selector);
	let swiper_slider = document.querySelectorAll('.swiper-slider-seasons');

	swiperSliders.forEach((slider, i) => {
		const swiper = new Swiper(slider, {
			modules: [Autoplay],
			spaceBetween: 10,
			loop: true,
			freeMode: true,
			speed: 350,
			effect: 'ease',
			autoplay: {
				// delay: 2500,
				disableOnInteraction: false
			},
			breakpoints: {
				0: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 4,
				},
			}
		});

	});
};
document.addEventListener('DOMContentLoaded', () => {
	swiperSliderSeasons('.swiper-slider-seasons');
});



const swiperSliderTestimonials = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider, i) => {

		let nearestSlider = slider.closest('section .swiper-slider-testimonials');
		let pagination = nearestSlider.querySelector('.swiper-pagination');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			modules: [Autoplay, Pagination],
			loop: true,
			spaceBetween: 200,
			pauseOnMouseEnter: true,
			speed: 600,
			autoplay: {
				delay: 7500,
			},
			pagination: {
				el: slidesCount > 1 ? pagination : null,
				clickable: true,
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
			}
		});
	});
};
document.addEventListener('DOMContentLoaded', () => {
	swiperSliderTestimonials('.swiper-slider-testimonials');
});


const swiperSliderNews = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);

	swiperSliders.forEach((slider, i) => {
		let nearestSlider = slider.closest('section .swiper-slider-news');
		let pagination = nearestSlider.querySelector('.swiper-pagination');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			modules: [Autoplay, Pagination],
			loop: true,
			pauseOnMouseEnter: true,
			speed: 600,
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: slidesCount > 1 ? pagination : null,
				clickable: true,
			},
			spaceBetween: 200,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
			},
			on: {
				slideChange: function () {
					lazyLoadImages();
				}
			}
		});
	});
};
document.addEventListener('DOMContentLoaded', () => {
	swiperSliderNews('.swiper-slider-news');
});

const swiperSliderMedia = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider, i) => {

		let nearestSlider = slider.closest('section');
		let prev = nearestSlider.querySelector('.swiper-button-prev');
		let next = nearestSlider.querySelector('.swiper-button-next');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			modules: [Autoplay, Navigation],
			direction: 'horizontal',
			reverseDirection: 'false',
			autoHeight: false,
			loop: true,
			speed: 600,
			autoplay: {
				delay: 5000,
			},
			slidesPerView: 1,
			navigation: {
				prevEl: prev,
				nextEl: next,
			},
			centeredSlides: false,
			touchStartPreventDefault: false,
			spaceBetween: 200,
			on: {
				slideChange: function () {
					lazyLoadImages();
				}
			}
		});
	});
};
document.addEventListener('DOMContentLoaded', () => {
	swiperSliderMedia('.swiper-slider-media');
});

const swiperSliderAccreditations = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);

	swiperSliders.forEach((slider, i) => {
		let nearestSlider = slider.closest('.hero');
		let prev = nearestSlider.querySelector('.swiper-button-prev');
		let next = nearestSlider.querySelector('.swiper-button-next');
		let pagination = nearestSlider.querySelector('.swiper-pagination');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			modules: [Autoplay],
			loop: true,
			spaceBetween: 75,
			// speed: 6000,
			// freeMode: true,
			// autoplay: {
			// 	delay: 0,
			// 	disableOnInteraction: false
			// },
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				480: {
					slidesPerView: 3,
					spaceBetween: 50
				},
				767: {
					slidesPerView: 6,
				},
			}
		});
	});
};
document.addEventListener('DOMContentLoaded', () => {
	swiperSliderAccreditations('.swiper-slider-accreditations-header');
});

const swiperSliderAccreditationsFooter = (selector) => {

	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider, i) => {

		let nearestSlider = slider.closest('footer');
		let prev = nearestSlider.querySelector('.swiper-button-prev');
		let next = nearestSlider.querySelector('.swiper-button-next');
		let pagination = nearestSlider.querySelector('.swiper-pagination');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 50,
			breakpoints: {
				0: {
					slidesPerView: 2,
				},
				480: {
					slidesPerView: 3,
				},
				767: {
					slidesPerView: 5,
				},
			},
		});

	});
};
document.addEventListener('DOMContentLoaded', () => {
	swiperSliderAccreditationsFooter('.swiper-slider-accreditations-footer');
});
